import { render, staticRenderFns } from "./myAppoint.vue?vue&type=template&id=250031d7&scoped=true"
import script from "./myAppoint.vue?vue&type=script&lang=js"
export * from "./myAppoint.vue?vue&type=script&lang=js"
import style0 from "./myAppoint.vue?vue&type=style&index=0&id=250031d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250031d7",
  null
  
)

export default component.exports